"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc20ConversionProxy__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_paymentProxyAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_chainlinkConversionPathAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "currency",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes",
                name: "paymentReference",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "feeAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "maxRateTimespan",
                type: "uint256",
            },
        ],
        name: "TransferWithConversionAndReference",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bytes",
                name: "paymentReference",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "feeAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "feeAddress",
                type: "address",
            },
        ],
        name: "TransferWithReferenceAndFee",
        type: "event",
    },
    {
        inputs: [],
        name: "chainlinkConversionPath",
        outputs: [
            {
                internalType: "contract ChainlinkConversionPath",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "paymentProxy",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_requestAmount",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "_path",
                type: "address[]",
            },
            {
                internalType: "bytes",
                name: "_paymentReference",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "_feeAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_feeAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_maxToSpend",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_maxRateTimespan",
                type: "uint256",
            },
        ],
        name: "transferFromWithReferenceAndFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_chainlinkConversionPathAddress",
                type: "address",
            },
        ],
        name: "updateConversionPathAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_paymentProxyAddress",
                type: "address",
            },
        ],
        name: "updateConversionProxyAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class Erc20ConversionProxy__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(_paymentProxyAddress, _chainlinkConversionPathAddress, _owner, overrides) {
        return super.deploy(_paymentProxyAddress, _chainlinkConversionPathAddress, _owner, overrides || {});
    }
    getDeployTransaction(_paymentProxyAddress, _chainlinkConversionPathAddress, _owner, overrides) {
        return super.getDeployTransaction(_paymentProxyAddress, _chainlinkConversionPathAddress, _owner, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Erc20ConversionProxy__factory = Erc20ConversionProxy__factory;
Erc20ConversionProxy__factory.bytecode = _bytecode;
Erc20ConversionProxy__factory.abi = _abi;
